import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-header-logo',
  templateUrl: './header-logo.component.html'
})
export class HeaderLogoComponent implements OnInit {

  @Input() logo
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
